// extracted by mini-css-extract-plugin
module.exports = {"page":"style_page__vpxz9","logo":"style_logo__3HmjK","form":"style_form__3ZGW5"};